import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { ActionControlSize } from "@1js/acui-common";
import type { AppGalleryStyles } from "@1js/acui-gallery";
import { concatAppGalleryStyles } from "@1js/acui-gallery";

import { getLargePreviewGalleryStyles } from "./largePreviewGalleryStyles";

const largeFontGallerySharedStyles = {
  root: {
    width: 95,
  },
  flexContainer: {
    justifyContent: "center",
  },
  // Set minWidth on the container so the contents ellipsis-ify instead
  // of go outside the flex container
  textContainer: {
    minWidth: 10,
  },
  // Remove the padding applied, there shouldn't be any padding for the large form button
  label: {
    padding: "unset",
    textOverflow: "ellipsis",
    textAlign: "center",
  },
};

const largeFontGalleryStyles: Partial<AppGalleryStyles> = {
  galleryButtonInExpanded: largeFontGallerySharedStyles,
  galleryButtonInPreview: largeFontGallerySharedStyles,
};

export const getRibbonSizedFontGalleryStyles = memoizeFunction(
  (
    size: ActionControlSize | undefined,
    externalStyles: Partial<AppGalleryStyles> | undefined
  ): Partial<AppGalleryStyles> => {
    if (size === ActionControlSize.Large) {
      return concatAppGalleryStyles(
        getLargePreviewGalleryStyles(),
        largeFontGalleryStyles,
        externalStyles
      );
    }
    return externalStyles || {};
  }
);
